"use client";
import React, { useMemo } from "react";
import {
  MaterialReactTable,
  type MRT_ColumnDef,
  type MRT_RowSelectionState,
} from "material-react-table";
import { Box, Typography } from "@mui/material";

// Demo dataset (you can later fetch this from API or CSV)
const demoData = [
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Daily CPC Blend CIF (Platts) vs Dated Brent (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "DCW",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Brent CFD vs 1st Month",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "CFD",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Brent CFD vs 2nd month",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "CFT",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Daily WTI Midland DAP Augusta (Platts) vs Dated Brent (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "CGH",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Daily WTI Midland DAP Rotterdam (Platts) vs Dated Brent (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "CGG",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Daily Dated Brent (Platts) vs Brent 2nd Line",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "DBS",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Daily Dated Brent (Platts)/Mediterranean Dated Strip (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "DDM",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Brent Bullet CFD vs 3rd month 1000bbl (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BUM",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Brent Bullet CFD vs 2nd month 1000bbl",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BTM",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Daily Dated Brent vs Brent 1st Line",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "DBL",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "Brent Bullet CFD vs 1st month 1000bbl",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BSM",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Diff Futures",
    HubName: "CPC Blend CIF (Platts) vs Dated Brent (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "DCR",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Futures",
    HubName: "Brent Cash Settled European Option",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BUL",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Futures",
    HubName: "Daily Dated Brent 1000bbl",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "DDB",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Futures",
    HubName: "Daily BFOET (Platts) M3",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BF3",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Futures",
    HubName: "Daily BFOET (Platts) M2",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BF2",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Crude Futures",
    HubName: "Daily BFOET (Platts) M1",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BF1",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Jet Fuel Crack Futures",
    HubName: "Jet CIF NWE Cargoes vs Brent 1st line",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "JNB",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Jet Fuel Futures",
    HubName: "Jet CIF NWE Cargoes",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "JCN",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Jet Fuel Futures",
    HubName: "Jet CIF NWE Cargoes Platts Mini",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "JCM",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Crack Futures",
    HubName: "Low Sulphur Gasoil 1st Line vs Brent 1st Line",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "ULC",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Futures",
    HubName: "Low Sulphur Gasoil 1st Line",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "ULA",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Crack Futures (bbl)",
    HubName: "Low Sulphur Gasoil 1st Line vs Brent 1st Line Mini",
    LotSize: 100,
    Unit: "bbl",
    PhysicalCode: "LVB",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Futures",
    HubName: "Low Sulphur Gasoil Bullet",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "UUB",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Crack Futures (bbl)",
    HubName: "Low Sulphur Gasoil 1st Line vs Brent 1st Line",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "ULD",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Fuel Oil Futures",
    HubName: "Marine Fuel 0.5% FOB Rotterdam Barges (Platts) Mini",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "MFY",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoline Crack Futures",
    HubName:
      "Argus Eurobob Non-Oxy FOB Rotterdam Barge vs Brent 1st Line (bbl)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "AEA",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Fuel Oil Futures",
    HubName: "Marine Fuel 0.5% FOB Rotterdam Barges (Platts)",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "MF3",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoline Futures",
    HubName: "Eurobob Non Oxy Gasoline NWE FOB Barges (GX) Mini",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "MHK",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoline Futures",
    HubName: "Eurobob Non Oxy Gasoline NWE FOB Barges (GX)",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "MHI",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Jet Fuel Futures",
    HubName: "Middle East Jet Kero FOB Arab Gulf (Platts) Mini",
    LotSize: 100,
    Unit: "bbl",
    PhysicalCode: "MHG",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Futures",
    HubName: "Low Sulphur Gasoil CSO 1 Month",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "UUM",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Futures",
    HubName: "Low Sulphur Gasoil CSO 12 Month",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "UUZ",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Naphtha Futures",
    HubName: "Naphtha C&F Japan Cargoes",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "NJC",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Naphtha Futures",
    HubName: "Naphtha CIF NWE Cargoes",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "NEC",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Jet Fuel Futures",
    HubName: "Middle East Jet Kero FOB Arab Gulf (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "GCV",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Fuel Oil Futures",
    HubName: "Marine Fuel 0.5% FOB Singapore (Platts)",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "MF4",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Naphtha Crack Futures",
    HubName: "Naphtha CIF NWE Cargoes vs Brent 1st Line",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "NOB",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Naphtha Futures (bbl)",
    HubName: "Naphtha CIF NWE Cargoes (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "NBA",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Naphtha Crack Futures (bbl)",
    HubName: "Naphtha CIF NWE Cargoes (Platts) vs Brent 1st Line",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "NBB",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Naphtha Futures",
    HubName: "Naphtha CIF NWE Cargoes (Platts) Mini",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "NAM",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Fuel Oil Futures",
    HubName: "Marine Fuel 0.5% FOB Singapore (Platts) Mini",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "MFZ",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Fuel Oil Diff Futures",
    HubName:
      "Marine Fuel 0.5% FOB Singapore vs Fuel Oil 380 CST Singapore (Platts)",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "MF6",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Fuel Oil Diff Futures",
    HubName:
      "Marine Fuel 0.5% FOB Singapore (Platts) vs Fuel Oil 380 CST Singapore (Platts) Mini",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "MDG",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Diff Futures",
    HubName:
      "Singapore Gasoil 10ppm (Platts) vs Singapore Gasoil 0.05% (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "GSW",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Futures",
    HubName: "Singapore Gasoil 10ppm (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "GST",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Futures",
    HubName: "Singapore Gasoil 0.05% (Platts) Mini",
    LotSize: 100,
    Unit: "bbl",
    PhysicalCode: "SWM",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Arb Futures",
    HubName: "Singapore Gasoil 10ppm (Platts) vs Low Sulphur Gasoil 1st Line",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BAP",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Crack Futures",
    HubName: "Singapore Gasoil 10ppm (Platts) vs Dubai 1st Line (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BAO",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Futures",
    HubName: "Singapore Gasoil 0.05% (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "SWS",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Futures",
    HubName: "Singapore Gasoil 10ppm (Platts) Mini",
    LotSize: 100,
    Unit: "bbl",
    PhysicalCode: "GSR",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Jet Fuel Crack Futures",
    HubName: "Singapore Kerosene (Platts) vs Dubai 1st line (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "SFF",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Jet Fuel Futures",
    HubName: "Singapore Kerosene",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "SRS",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Jet Fuel Diff Futures",
    HubName:
      "Singapore Kerosene Cargoes (Platts) vs Singapore Gasoil 10ppm (Platts)",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "BAQ",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Gasoil Arb Futures",
    HubName: "Singapore Gasoil 0.05% (Platts) vs Low Sulphur Gasoil 1st Line",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "SWW",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Diesel Futures",
    HubName: "ULSD 10ppm CIF NWE Cargoes (Platts) Mini",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "14Y",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Diesel Diff Futures",
    HubName: "ULSD 10ppm CIF NWE Cargoes vs Low Sulphur Gasoil 1st Line",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "ULF",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Diesel Futures",
    HubName: "ULSD 10ppm CIF NWE Cargoes",
    LotSize: 1000,
    Unit: "mt",
    PhysicalCode: "ULN",
  },
  {
    MarketTypeName: "Oil",
    ProductName: "Diesel Crack Futures",
    HubName: "ULSD 10ppm CIF NWE Cargoes vs Brent 1st Line",
    LotSize: 1000,
    Unit: "bbl",
    PhysicalCode: "UBN",
  },
  {
    MarketTypeName: "IPE Gas Oil Futures",
    ProductName: "LS Gas Oil TAS",
    HubName: "Low Sulphur Antwerp Rotterdam Amsterdam",
    LotSize: 100,
    Unit: "mt",
    PhysicalCode: "G",
  },
];

const SecurityDefinitions = () => {
  const columns = useMemo<MRT_ColumnDef<(typeof demoData)[0]>[]>(
    () => [
      { accessorKey: "MarketTypeName", header: "Market Type Name" },
      { accessorKey: "ProductName", header: "Product Name" },
      { accessorKey: "HubName", header: "Hub Name" },
      { accessorKey: "LotSize", header: "Lot Size" },
      { accessorKey: "Unit", header: "Unit" },
      { accessorKey: "PhysicalCode", header: "Physical Code" },
    ],
    []
  );

  return (
    <Box sx={{ flexGrow: 1, mt: 20, mb: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Security Definitions
      </Typography>

      <Box className="custom-table-wrapper">
        <MaterialReactTable
          columns={columns}
          data={demoData}
          enableColumnFilters
          enablePagination
          enableSorting
          enableGrouping
          enableExpanding
          enableColumnDragging
          enableColumnOrdering
          enableRowVirtualization
          enableStickyHeader={false}
          enableDensityToggle
          enableFullScreenToggle
          enableColumnPinning
          enableGlobalFilter
          initialState={{
            density: "compact",
            pagination: { pageSize: 20, pageIndex: 0 },
            showColumnFilters: true,
          }}
          renderDetailPanel={({ row }: any) => (
            <Box sx={{ p: 2, fontSize: "0.50rem" }}>
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                Record Details:
              </Typography>
              <pre style={{ fontSize: "0.7rem" }}>
                {JSON.stringify(row.original, null, 2)}
              </pre>
            </Box>
          )}
          muiTableContainerProps={{
            sx: {
              border: "1px solid #e0e0e0",
              maxHeight: "none",
              position: "relative", // 🔑 Create stacking context
              zIndex: 1, // 🔑 Lower than navbar
            },
            className: "table-container"
          }}
          muiTableHeadCellProps={{
            sx: {
              borderRight: "1px solid #e0e0e0",
              bgcolor: "#fff",
              fontWeight: "bold",
              fontSize: "0.7rem",
              padding: "2px 6px",
              lineHeight: 1.2,
              position: "static !important",
              top: "auto !important",
              zIndex: "1 !important", // 🔑 Lower z-index
            },
          }}
          muiTableBodyCellProps={{
            sx: {
              borderRight: "1px solid #e0e0e0",
              fontSize: "0.65rem",
              padding: "2px 6px",
              lineHeight: 1.2,
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              height: "13px",
              "&:hover": { backgroundColor: "#f9fafb" },
            },
          }}
          muiTablePaperProps={{
            className: "table-paper",
            sx: {
              overflow: "visible",
              position: "relative", // 🔑 Create stacking context
              zIndex: 1, // 🔑 Lower than navbar
            }
          }}
          muiTableHeadProps={{
            sx: {
              position: "static !important",
              zIndex: "1 !important", // 🔑 Lower z-index
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default SecurityDefinitions;
